// extracted by mini-css-extract-plugin
module.exports = {"header":"card-header_header__2WuT6","title":"card-header_title__hvrx9","chidren_wrapper":"card-header_chidren_wrapper__2LDHj"};